export default __webpack_public_path__ + "static/media/convay_game_of_life_preview.4bdb5bf0.png";